export enum RentInvoicingOrderStatus {
  Pending = 1,
  Unattested = 3,
  Completed = 10,
  Failed = 99,
}

export function RentInvoicingOrderStatusText(status: RentInvoicingOrderStatus): string {
  switch (status) {
    case RentInvoicingOrderStatus.Failed:
      return 'RENT_INVOICING_ORDER.STATUS_CODES.FAILED';
    case RentInvoicingOrderStatus.Unattested:
      return 'RENT_INVOICING_ORDER.STATUS_CODES.UNATTESTED';
    case RentInvoicingOrderStatus.Completed:
      return 'RENT_INVOICING_ORDER.STATUS_CODES.COMPLETED';
    default:
      return 'RENT_INVOICING_ORDER.STATUS_CODES.PENDING';
  }
}
